import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import Documento from "model/documentos/Documento";
import AdicionarRevisao from "model/documentos/fluxo/AdicionarRevisao";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

type Props = {
    visible: boolean;
    onHide: () => void;
    documento: Documento
    onConfirm: () => void;
}

const documentoPastaService = new DocumentoPastaService();
export default function ModalDocumentoAdicionarRevisao(props: Props) {

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();
    const [dados, setDados] = useState<AdicionarRevisao>(new AdicionarRevisao(props.documento.id, props.documento?.categoria?.aprovadorPadrao, undefined, props.documento?.categoria.revisorPadrao));

    const { control, setFocus, clearErrors, setError, formState: { errors } } = useForm();
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);

    function handleConfirm() {
        if (!validar()) {
            return;
        }
        startLoading();
        documentoPastaService.adicionarRevisao(dados).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao adicionar revisão", error?.data?.message || "");
            console.error("Erro ao adicionar revisão:", error);
        });

    }

    function validar() {
        if (!dados.responsavelRevisao) {
            setError("responsavelRevisao", { type: "manual", message: "Responsável Revisão é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!dados.prazoRevisao) {
            setError("prazoRevisao", { type: "manual", message: "Prazo para revisão é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (props.documento.categoria.temAprovacao) {
            if (!dados.responsavelAprovacao) {
                setError("responsavelAprovacao", { type: "manual", message: "Responsável Aprovação é Obrigatório" }, { shouldFocus: true })
                return false;
            }
            if (!dados.prazoAprovacao) {
                setError("prazoAprovacao", { type: "manual", message: "Prazo para aprovação é Obrigatório" }, { shouldFocus: true })
                return false;
            }
        }

        return true;
    }

    useEffect(() => {
        documentoPastaService.usuarios().then((json) => {
            setUsuarios(json);
        }).catch((error) => {
            console.error("Erro ao buscar usuários:", error);
        });
    }, [])

    return (
        <Dialog
            header="Definições da revisão"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Adicionar" icon="pi pi-plus" onClick={handleConfirm} />
            </>}
        >
            <div>
                <Label>Motivo</Label>
                <InputTextarea rows={3} value={dados.observacaoParaRevisao || ""} onChange={(e) => {
                    setDados({ ...dados, observacaoParaRevisao: e.target.value });
                }} style={{ width: '100%' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', columnGap: 12, marginBottom: '1rem' }}>

                <div className="col-md-6">
                    <Label obrigatorio>Responsável Revisão</Label>
                    <Controller name="responsavelRevisao" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            value={dados.responsavelRevisao}
                            placeholder="Selecione um usuário"
                            style={{ width: '100%' }}
                            className={errors.responsavelRevisao ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                            suggestions={usuariosFiltrados}
                            completeMethod={(e) => {
                                let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                setUsuariosFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dados));

                                if (!e.target.value) {
                                    finalizarElaboracaoLocal.responsavelRevisao = null;
                                } else if (typeof e.target.value == "string") {
                                    let usuario = new Usuario();
                                    usuario.nome = e.target.value;
                                    finalizarElaboracaoLocal.responsavelRevisao = usuario;
                                } else {
                                    finalizarElaboracaoLocal.responsavelRevisao = e.target.value;
                                }
                                clearErrors("responsavelRevisao");
                                setDados(finalizarElaboracaoLocal);
                            }}
                        />
                    )} />
                    {errors.responsavelRevisao && errors.responsavelRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelRevisao?.message as string}</span> : null}
                </div>

                <div className="col-md-6 ">
                    <Label obrigatorio>Prazo para Revisão</Label>
                    <Controller name="prazoRevisao" control={control} render={({ field }) => (
                        <DatePicker
                            inputRef={field.ref}
                            value={dayjs(dados.prazoRevisao)}
                            onChange={value => {
                                clearErrors("prazoRevisao")
                                setDados({ ...dados, prazoRevisao: value?.startOf("day").toDate() || null })
                            }}
                        />
                    )} />
                    {errors.prazoRevisao && errors.prazoRevisao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.prazoRevisao?.message as string}</span> : null}
                </div>
            </div>

            {props.documento.categoria.temAprovacao ?
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', columnGap: 12, marginBottom: '1rem' }}>
                        <div className="col col-sm-6">
                            <Label className="col col-sm-12" obrigatorio>Responsável Aprovação</Label>
                            <Controller name="responsavelAprovacao" control={control} render={({ field }) => (
                                <AutoComplete
                                    inputRef={field.ref}
                                    dropdown
                                    value={dados.responsavelAprovacao}
                                    placeholder="Selecione um usuário"
                                    style={{ width: '100%' }}
                                    className={errors.responsavelAprovacao ? "p-invalid" : ""}
                                    field="nome"
                                    itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                                    suggestions={usuariosFiltrados}
                                    completeMethod={(e) => {
                                        let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                                        setUsuariosFiltrados(filtered);
                                    }}
                                    onChange={(e) => {
                                        let finalizarElaboracaoLocal = JSON.parse(JSON.stringify(dados));

                                        if (!e.target.value) {
                                            finalizarElaboracaoLocal.responsavelAprovacao = null;
                                        } else if (typeof e.target.value == "string") {
                                            let usuario = new Usuario();
                                            usuario.nome = e.target.value;
                                            finalizarElaboracaoLocal.responsavelAprovacao = usuario;
                                        } else {
                                            finalizarElaboracaoLocal.responsavelAprovacao = e.target.value;
                                        }
                                        clearErrors("responsavelAprovacao")
                                        setDados(finalizarElaboracaoLocal);
                                    }}
                                />
                            )} />
                            {errors.responsavelAprovacao && errors.responsavelAprovacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.responsavelAprovacao?.message as string}</span> : null}
                        </div>
                        <div className="col-md-6">
                            <Label obrigatorio>Prazo para Aprovação</Label>
                            <Controller name="prazoAprovacao" control={control} render={({ field }) => (
                                <DatePicker
                                    inputRef={field.ref}
                                    value={dayjs(dados.prazoAprovacao)}
                                    onChange={value => {
                                        clearErrors("prazoRevisao")
                                        setDados({ ...dados, prazoAprovacao: value?.startOf("day").toDate() || null })
                                    }}
                                />
                            )} />
                            {errors.dataInicio && errors.dataInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicio?.message as string}</span> : null}
                        </div>
                    </div>
                </> : null}

        </Dialog>
    );
}